window.Crisp = {
  currentView: null,

  isAvailable: function () {
    return typeof window.$crisp !== "undefined";
  },

  init: function () {
    if (!this.isAvailable()) return;

    $crisp.push(["safe", true]);

    $crisp.push(["do", "chat:hide"]);
    $crisp.push(["do", "chat:hide:launcher"]);

    $crisp.push([
      "on",
      "chat:closed",
      function () {
        this.currentView = null;
      }.bind(this),
    ]);
  },

  waitForConversationButton: function (timeout) {
    timeout = timeout || 3000;

    var labels = [
      "Conversar",
      "Conversação",
      "Conversa",
      "Conversation",
      "Chat",
    ];

    return new Promise(function (resolve) {
      var start = Date.now();

      var interval = setInterval(function () {
        var chatbox = document.getElementById("crisp-chatbox");

        if (!chatbox) {
          if (Date.now() - start > timeout) {
            clearInterval(interval);
            resolve(null);
          }

          return;
        }

        var button = Array.from(
          chatbox.querySelectorAll('[role="button"][aria-label]'),
        ).find(function (el) {
          var label = el.getAttribute("aria-label") || "";

          return labels.some(function (text) {
            return label.indexOf(text) !== -1;
          });
        });

        if (button) {
          clearInterval(interval);
          resolve(button);
          return;
        }

        if (Date.now() - start > timeout) {
          clearInterval(interval);
          resolve(null);
        }
      }, 50);
    });
  },

  openConversation: async function () {
    $crisp.push(["do", "chat:show"]);
    $crisp.push(["do", "chat:open"]);

    var button = await this.waitForConversationButton();

    if (button) {
      button.click();
    }

    this.currentView = "chat";
  },

  toggle: function (tab) {
    if (!this.isAvailable()) return;

    // Com o carregamento adiado, o clique pode chegar antes do SDK: pede o SDK na hora. Até ele
    // chegar, $crisp ainda é a fila (sem `is`), e os comandos abaixo esperam nela.
    if (window.hospedinLoadLater) window.hospedinLoadLater.flush();

    var isOpened = typeof $crisp.is === "function" && $crisp.is("chat:opened");

    if (isOpened && this.currentView === tab) {
      $crisp.push(["do", "chat:close"]);
      this.currentView = null;
      return;
    }

    if (tab === "chat") {
      this.openConversation();
      return;
    }

    if (tab === "helpdesk") {
      $crisp.push(["do", "chat:show"]);
      $crisp.push(["do", "chat:open"]);
      $crisp.push(["do", "helpdesk:search"]);

      this.currentView = "helpdesk";
    }
  },
};
